// extracted by mini-css-extract-plugin
module.exports = {"w1cfiaze":"w1cfiaze","ikae2xy":"ikae2xy","iife6a":"iife6a"};